export type FitmentStatus = 'success' | 'universal' | 'failure' | 'no-fitment';

interface Params {
  fitsVehicle?: boolean;
  isUniversal?: boolean;
  hasFitment?: boolean;
}

export const getFitmentStatus = ({
  fitsVehicle,
  hasFitment,
  isUniversal,
}: Params): FitmentStatus => {
  if (fitsVehicle) {
    return 'success';
  }

  if (isUniversal) {
    return 'universal';
  }

  if (hasFitment === false) {
    return 'no-fitment';
  }

  return 'failure';
};
